/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createPost = /* GraphQL */ `
  mutation CreatePost(
    $input: CreatePostInput!
    $condition: ModelPostConditionInput
  ) {
    createPost(input: $input, condition: $condition) {
      id
      title
      blog {
        id
        name
        author
        createdAt
        updatedAt
        owner
        __typename
      }
      comments {
        nextToken
        __typename
      }
      blogID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePost = /* GraphQL */ `
  mutation UpdatePost(
    $input: UpdatePostInput!
    $condition: ModelPostConditionInput
  ) {
    updatePost(input: $input, condition: $condition) {
      id
      title
      blog {
        id
        name
        author
        createdAt
        updatedAt
        owner
        __typename
      }
      comments {
        nextToken
        __typename
      }
      blogID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePost = /* GraphQL */ `
  mutation DeletePost(
    $input: DeletePostInput!
    $condition: ModelPostConditionInput
  ) {
    deletePost(input: $input, condition: $condition) {
      id
      title
      blog {
        id
        name
        author
        createdAt
        updatedAt
        owner
        __typename
      }
      comments {
        nextToken
        __typename
      }
      blogID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createComment = /* GraphQL */ `
  mutation CreateComment(
    $input: CreateCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    createComment(input: $input, condition: $condition) {
      id
      post {
        id
        title
        blogID
        createdAt
        updatedAt
        __typename
      }
      content
      createdAt
      updatedAt
      postCommentsId
      __typename
    }
  }
`;
export const updateComment = /* GraphQL */ `
  mutation UpdateComment(
    $input: UpdateCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    updateComment(input: $input, condition: $condition) {
      id
      post {
        id
        title
        blogID
        createdAt
        updatedAt
        __typename
      }
      content
      createdAt
      updatedAt
      postCommentsId
      __typename
    }
  }
`;
export const deleteComment = /* GraphQL */ `
  mutation DeleteComment(
    $input: DeleteCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    deleteComment(input: $input, condition: $condition) {
      id
      post {
        id
        title
        blogID
        createdAt
        updatedAt
        __typename
      }
      content
      createdAt
      updatedAt
      postCommentsId
      __typename
    }
  }
`;
export const createSeries = /* GraphQL */ `
  mutation CreateSeries(
    $input: CreateSeriesInput!
    $condition: ModelSeriesConditionInput
  ) {
    createSeries(input: $input, condition: $condition) {
      id
      title
      description
      plot
      releaseDate
      seasons {
        nextToken
        __typename
      }
      contents {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateSeries = /* GraphQL */ `
  mutation UpdateSeries(
    $input: UpdateSeriesInput!
    $condition: ModelSeriesConditionInput
  ) {
    updateSeries(input: $input, condition: $condition) {
      id
      title
      description
      plot
      releaseDate
      seasons {
        nextToken
        __typename
      }
      contents {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteSeries = /* GraphQL */ `
  mutation DeleteSeries(
    $input: DeleteSeriesInput!
    $condition: ModelSeriesConditionInput
  ) {
    deleteSeries(input: $input, condition: $condition) {
      id
      title
      description
      plot
      releaseDate
      seasons {
        nextToken
        __typename
      }
      contents {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createAlbum = /* GraphQL */ `
  mutation CreateAlbum(
    $input: CreateAlbumInput!
    $condition: ModelAlbumConditionInput
  ) {
    createAlbum(input: $input, condition: $condition) {
      id
      title
      description
      contents {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateAlbum = /* GraphQL */ `
  mutation UpdateAlbum(
    $input: UpdateAlbumInput!
    $condition: ModelAlbumConditionInput
  ) {
    updateAlbum(input: $input, condition: $condition) {
      id
      title
      description
      contents {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteAlbum = /* GraphQL */ `
  mutation DeleteAlbum(
    $input: DeleteAlbumInput!
    $condition: ModelAlbumConditionInput
  ) {
    deleteAlbum(input: $input, condition: $condition) {
      id
      title
      description
      contents {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createSeason = /* GraphQL */ `
  mutation CreateSeason(
    $input: CreateSeasonInput!
    $condition: ModelSeasonConditionInput
  ) {
    createSeason(input: $input, condition: $condition) {
      id
      seriesId
      title
      seasonNumber
      contents {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateSeason = /* GraphQL */ `
  mutation UpdateSeason(
    $input: UpdateSeasonInput!
    $condition: ModelSeasonConditionInput
  ) {
    updateSeason(input: $input, condition: $condition) {
      id
      seriesId
      title
      seasonNumber
      contents {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteSeason = /* GraphQL */ `
  mutation DeleteSeason(
    $input: DeleteSeasonInput!
    $condition: ModelSeasonConditionInput
  ) {
    deleteSeason(input: $input, condition: $condition) {
      id
      seriesId
      title
      seasonNumber
      contents {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createContent = /* GraphQL */ `
  mutation CreateContent(
    $input: CreateContentInput!
    $condition: ModelContentConditionInput
  ) {
    createContent(input: $input, condition: $condition) {
      id
      seasonId
      
      seriesId
      
      albumId
      
      agreementId
      status
      title
      type
      category
      director
      actors
      duration
      releaseDate
      synopsis
      language
      filePath
      masterSubtitleFilePath
      trailerFilePath
      trailerSubtitleFilePath
      artist
      composer
      imdbRating
      rottenRating
      rating
      studios
      country
      year
      posters
      fileSize
      creators
      author
      genre
      publisher
      publicationYear
      isGrouped
      isAlbum
      isSeries
      isDrmProtected
      isDrmEncodedSuccessfully
      isOneDrive
      sequence
      axinomDrmEncodingJobId
      encodedFilePath
      encodedFolderPath
      currentCycle
      feedbacks {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateContent = /* GraphQL */ `
  mutation UpdateContent(
    $input: UpdateContentInput!
    $condition: ModelContentConditionInput
  ) {
    updateContent(input: $input, condition: $condition) {
      id
      seasonId
      
      seriesId
      
      albumId
      
      agreementId
      
      status
      title
      type
      category
      director
      actors
      duration
      releaseDate
      synopsis
      language
      filePath
      masterSubtitleFilePath
      trailerFilePath
      trailerSubtitleFilePath
      artist
      composer
      imdbRating
      rottenRating
      rating
      studios
      country
      year
      posters
      fileSize
      creators
      author
      genre
      publisher
      publicationYear
      isGrouped
      isAlbum
      isSeries
      isDrmProtected
      isDrmEncodedSuccessfully
      isOneDrive
      sequence
      axinomDrmEncodingJobId
      encodedFilePath
      encodedFolderPath
      currentCycle
      feedbacks {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteContent = /* GraphQL */ `
  mutation DeleteContent(
    $input: DeleteContentInput!
    $condition: ModelContentConditionInput
  ) {
    deleteContent(input: $input, condition: $condition) {
      id
      seasonId
      
      seriesId
      
      albumId
      
      agreementId
      
      status
      title
      type
      category
      director
      actors
      duration
      releaseDate
      synopsis
      language
      filePath
      masterSubtitleFilePath
      trailerFilePath
      trailerSubtitleFilePath
      artist
      composer
      imdbRating
      rottenRating
      rating
      studios
      country
      year
      posters
      fileSize
      creators
      author
      genre
      publisher
      publicationYear
      isGrouped
      isAlbum
      isSeries
      isDrmProtected
      isDrmEncodedSuccessfully
      isOneDrive
      sequence
      axinomDrmEncodingJobId
      encodedFilePath
      encodedFolderPath
      currentCycle
      feedbacks {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createFeedback = /* GraphQL */ `
  mutation CreateFeedback(
    $input: CreateFeedbackInput!
    $condition: ModelFeedbackConditionInput
  ) {
    createFeedback(input: $input, condition: $condition) {
      id
      contentId
      
      overallComment
      timestamps {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      adminId
      __typename
    }
  }
`;
export const updateFeedback = /* GraphQL */ `
  mutation UpdateFeedback(
    $input: UpdateFeedbackInput!
    $condition: ModelFeedbackConditionInput
  ) {
    updateFeedback(input: $input, condition: $condition) {
      id
      contentId
      content {
        id
        seasonId
        seriesId
        albumId
        agreementId
        status
        title
        type
        category
        director
        actors
        duration
        releaseDate
        synopsis
        language
        filePath
        masterSubtitleFilePath
        trailerFilePath
        trailerSubtitleFilePath
        artist
        composer
        imdbRating
        rottenRating
        rating
        studios
        country
        year
        posters
        fileSize
        creators
        author
        genre
        publisher
        publicationYear
        isGrouped
        isAlbum
        isSeries
        isDrmProtected
        isDrmEncodedSuccessfully
        isOneDrive
        sequence
        axinomDrmEncodingJobId
        encodedFilePath
        encodedFolderPath
        currentCycle
        createdAt
        updatedAt
        owner
        __typename
      }
      overallComment
      timestamps {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      adminId
      __typename
    }
  }
`;
export const deleteFeedback = /* GraphQL */ `
  mutation DeleteFeedback(
    $input: DeleteFeedbackInput!
    $condition: ModelFeedbackConditionInput
  ) {
    deleteFeedback(input: $input, condition: $condition) {
      id
      contentId
      content {
        id
        seasonId
        seriesId
        albumId
        agreementId
        status
        title
        type
        category
        director
        actors
        duration
        releaseDate
        synopsis
        language
        filePath
        masterSubtitleFilePath
        trailerFilePath
        trailerSubtitleFilePath
        artist
        composer
        imdbRating
        rottenRating
        rating
        studios
        country
        year
        posters
        fileSize
        creators
        author
        genre
        publisher
        publicationYear
        isGrouped
        isAlbum
        isSeries
        isDrmProtected
        isDrmEncodedSuccessfully
        isOneDrive
        sequence
        axinomDrmEncodingJobId
        encodedFilePath
        encodedFolderPath
        currentCycle
        createdAt
        updatedAt
        owner
        __typename
      }
      overallComment
      timestamps {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      adminId
      __typename
    }
  }
`;
export const createTimestamp = /* GraphQL */ `
  mutation CreateTimestamp(
    $input: CreateTimestampInput!
    $condition: ModelTimestampConditionInput
  ) {
    createTimestamp(input: $input, condition: $condition) {
      id
      feedbackId
      type
      
      fromTime
      toTime
      comment
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateTimestamp = /* GraphQL */ `
  mutation UpdateTimestamp(
    $input: UpdateTimestampInput!
    $condition: ModelTimestampConditionInput
  ) {
    updateTimestamp(input: $input, condition: $condition) {
      id
      feedbackId
      type
      feedback {
        id
        contentId
        overallComment
        createdAt
        updatedAt
        adminId
        __typename
      }
      fromTime
      toTime
      comment
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteTimestamp = /* GraphQL */ `
  mutation DeleteTimestamp(
    $input: DeleteTimestampInput!
    $condition: ModelTimestampConditionInput
  ) {
    deleteTimestamp(input: $input, condition: $condition) {
      id
      feedbackId
      type
      feedback {
        id
        contentId
        overallComment
        createdAt
        updatedAt
        adminId
        __typename
      }
      fromTime
      toTime
      comment
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createAgreement = /* GraphQL */ `
  mutation CreateAgreement(
    $input: CreateAgreementInput!
    $condition: ModelAgreementConditionInput
  ) {
    createAgreement(input: $input, condition: $condition) {
      id
      companyName
      emailAddress
      dateOfAgreement
      officialAddress
      designation
      paymentDueDate
      technicalName
      technicalDesignation
      technicalEmail
      technicalPhoneNumber
      billingName
      billingDesignation
      billingEmail
      billingPhoneNumber
      signingAuthorityName
      commercialName
      commercialDesignation
      commercialEmail
      commercialPhoneNumber
      currency
      milestones
      partyA
      partyB
      daysOfAgreement
      licensingRegion
      licensingCountry
      carrierType
      numberOfRefreshCycles
      airline
      amountPaid
      amountRemaining
      numberOfMonthsPerCycle
      contractValue
      paymentStatus
      paymentPlan
      paymentTerm
      paymentModel
      paymentReceiptFilePath
      agreementFilePath
      contents {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateAgreement = /* GraphQL */ `
  mutation UpdateAgreement(
    $input: UpdateAgreementInput!
    $condition: ModelAgreementConditionInput
  ) {
    updateAgreement(input: $input, condition: $condition) {
      id
      companyName
      emailAddress
      dateOfAgreement
      officialAddress
      designation
      paymentDueDate
      technicalName
      technicalDesignation
      technicalEmail
      technicalPhoneNumber
      billingName
      billingDesignation
      billingEmail
      billingPhoneNumber
      signingAuthorityName
      commercialName
      commercialDesignation
      commercialEmail
      commercialPhoneNumber
      currency
      milestones
      partyA
      partyB
      daysOfAgreement
      licensingRegion
      licensingCountry
      carrierType
      numberOfRefreshCycles
      airline
      amountPaid
      amountRemaining
      numberOfMonthsPerCycle
      contractValue
      paymentStatus
      paymentPlan
      paymentTerm
      paymentModel
      paymentReceiptFilePath
      agreementFilePath
      contents {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteAgreement = /* GraphQL */ `
  mutation DeleteAgreement(
    $input: DeleteAgreementInput!
    $condition: ModelAgreementConditionInput
  ) {
    deleteAgreement(input: $input, condition: $condition) {
      id
      companyName
      emailAddress
      dateOfAgreement
      officialAddress
      designation
      paymentDueDate
      technicalName
      technicalDesignation
      technicalEmail
      technicalPhoneNumber
      billingName
      billingDesignation
      billingEmail
      billingPhoneNumber
      signingAuthorityName
      commercialName
      commercialDesignation
      commercialEmail
      commercialPhoneNumber
      currency
      milestones
      partyA
      partyB
      daysOfAgreement
      licensingRegion
      licensingCountry
      carrierType
      numberOfRefreshCycles
      airline
      amountPaid
      amountRemaining
      numberOfMonthsPerCycle
      contractValue
      paymentStatus
      paymentPlan
      paymentTerm
      paymentModel
      paymentReceiptFilePath
      agreementFilePath
      contents {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createPaymentDetails = /* GraphQL */ `
  mutation CreatePaymentDetails(
    $input: CreatePaymentDetailsInput!
    $condition: ModelPaymentDetailsConditionInput
  ) {
    createPaymentDetails(input: $input, condition: $condition) {
      id
      accountName
      IBANNumber
      bankName
      contractValue
      companyName
      swiftCode
      currency
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updatePaymentDetails = /* GraphQL */ `
  mutation UpdatePaymentDetails(
    $input: UpdatePaymentDetailsInput!
    $condition: ModelPaymentDetailsConditionInput
  ) {
    updatePaymentDetails(input: $input, condition: $condition) {
      id
      accountName
      IBANNumber
      bankName
      contractValue
      companyName
      swiftCode
      currency
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deletePaymentDetails = /* GraphQL */ `
  mutation DeletePaymentDetails(
    $input: DeletePaymentDetailsInput!
    $condition: ModelPaymentDetailsConditionInput
  ) {
    deletePaymentDetails(input: $input, condition: $condition) {
      id
      accountName
      IBANNumber
      bankName
      contractValue
      companyName
      swiftCode
      currency
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createBlog = /* GraphQL */ `
  mutation CreateBlog(
    $input: CreateBlogInput!
    $condition: ModelBlogConditionInput
  ) {
    createBlog(input: $input, condition: $condition) {
      id
      name
      author
      posts {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateBlog = /* GraphQL */ `
  mutation UpdateBlog(
    $input: UpdateBlogInput!
    $condition: ModelBlogConditionInput
  ) {
    updateBlog(input: $input, condition: $condition) {
      id
      name
      author
      posts {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteBlog = /* GraphQL */ `
  mutation DeleteBlog(
    $input: DeleteBlogInput!
    $condition: ModelBlogConditionInput
  ) {
    deleteBlog(input: $input, condition: $condition) {
      id
      name
      author
      posts {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createCategory = /* GraphQL */ `
  mutation CreateCategory(
    $input: CreateCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    createCategory(input: $input, condition: $condition) {
      id
      title
      type
      isActive
      Genres {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCategory = /* GraphQL */ `
  mutation UpdateCategory(
    $input: UpdateCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    updateCategory(input: $input, condition: $condition) {
      id
      title
      type
      isActive
      Genres {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCategory = /* GraphQL */ `
  mutation DeleteCategory(
    $input: DeleteCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    deleteCategory(input: $input, condition: $condition) {
      id
      title
      type
      isActive
      Genres {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createGenre = /* GraphQL */ `
  mutation CreateGenre(
    $input: CreateGenreInput!
    $condition: ModelGenreConditionInput
  ) {
    createGenre(input: $input, condition: $condition) {
      id
      title
      isActive
      categoryID
      category {
        id
        title
        type
        isActive
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateGenre = /* GraphQL */ `
  mutation UpdateGenre(
    $input: UpdateGenreInput!
    $condition: ModelGenreConditionInput
  ) {
    updateGenre(input: $input, condition: $condition) {
      id
      title
      isActive
      categoryID
      category {
        id
        title
        type
        isActive
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteGenre = /* GraphQL */ `
  mutation DeleteGenre(
    $input: DeleteGenreInput!
    $condition: ModelGenreConditionInput
  ) {
    deleteGenre(input: $input, condition: $condition) {
      id
      title
      isActive
      categoryID
      category {
        id
        title
        type
        isActive
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createVideoContent = /* GraphQL */ `
  mutation CreateVideoContent(
    $input: CreateVideoContentInput!
    $condition: ModelVideoContentConditionInput
  ) {
    createVideoContent(input: $input, condition: $condition) {
      id
      contentPath
      poster
      category
      title
      year
      rated
      released
      runtime
      genre
      director
      actors
      plot
      imdbRating
      tomatoMeter
      fileId
      tomatoRating
      onlyDeployMetaData
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateVideoContent = /* GraphQL */ `
  mutation UpdateVideoContent(
    $input: UpdateVideoContentInput!
    $condition: ModelVideoContentConditionInput
  ) {
    updateVideoContent(input: $input, condition: $condition) {
      id
      contentPath
      poster
      category
      title
      year
      rated
      released
      runtime
      genre
      director
      actors
      plot
      imdbRating
      tomatoMeter
      fileId
      tomatoRating
      onlyDeployMetaData
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteVideoContent = /* GraphQL */ `
  mutation DeleteVideoContent(
    $input: DeleteVideoContentInput!
    $condition: ModelVideoContentConditionInput
  ) {
    deleteVideoContent(input: $input, condition: $condition) {
      id
      contentPath
      poster
      category
      title
      year
      rated
      released
      runtime
      genre
      director
      actors
      plot
      imdbRating
      tomatoMeter
      fileId
      tomatoRating
      onlyDeployMetaData
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createGame = /* GraphQL */ `
  mutation CreateGame(
    $input: CreateGameInput!
    $condition: ModelGameConditionInput
  ) {
    createGame(input: $input, condition: $condition) {
      id
      providerId
      title
      year
      developer
      description
      howToPlay
      poster
      contentType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateGame = /* GraphQL */ `
  mutation UpdateGame(
    $input: UpdateGameInput!
    $condition: ModelGameConditionInput
  ) {
    updateGame(input: $input, condition: $condition) {
      id
      providerId
      title
      year
      developer
      description
      howToPlay
      poster
      contentType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteGame = /* GraphQL */ `
  mutation DeleteGame(
    $input: DeleteGameInput!
    $condition: ModelGameConditionInput
  ) {
    deleteGame(input: $input, condition: $condition) {
      id
      providerId
      title
      year
      developer
      description
      howToPlay
      poster
      contentType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createLanguage = /* GraphQL */ `
  mutation CreateLanguage(
    $input: CreateLanguageInput!
    $condition: ModelLanguageConditionInput
  ) {
    createLanguage(input: $input, condition: $condition) {
      id
      name
      nativeName
      code
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateLanguage = /* GraphQL */ `
  mutation UpdateLanguage(
    $input: UpdateLanguageInput!
    $condition: ModelLanguageConditionInput
  ) {
    updateLanguage(input: $input, condition: $condition) {
      id
      name
      nativeName
      code
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteLanguage = /* GraphQL */ `
  mutation DeleteLanguage(
    $input: DeleteLanguageInput!
    $condition: ModelLanguageConditionInput
  ) {
    deleteLanguage(input: $input, condition: $condition) {
      id
      name
      nativeName
      code
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createProvider = /* GraphQL */ `
  mutation CreateProvider(
    $input: CreateProviderInput!
    $condition: ModelProviderConditionInput
  ) {
    createProvider(input: $input, condition: $condition) {
      id
      name
      isActive
      contentType
      contentCategory
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateProvider = /* GraphQL */ `
  mutation UpdateProvider(
    $input: UpdateProviderInput!
    $condition: ModelProviderConditionInput
  ) {
    updateProvider(input: $input, condition: $condition) {
      id
      name
      isActive
      contentType
      contentCategory
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteProvider = /* GraphQL */ `
  mutation DeleteProvider(
    $input: DeleteProviderInput!
    $condition: ModelProviderConditionInput
  ) {
    deleteProvider(input: $input, condition: $condition) {
      id
      name
      isActive
      contentType
      contentCategory
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPointOfInterest = /* GraphQL */ `
  mutation CreatePointOfInterest(
    $input: CreatePointOfInterestInput!
    $condition: ModelPointOfInterestConditionInput
  ) {
    createPointOfInterest(input: $input, condition: $condition) {
      id
      name
      languageKey
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePointOfInterest = /* GraphQL */ `
  mutation UpdatePointOfInterest(
    $input: UpdatePointOfInterestInput!
    $condition: ModelPointOfInterestConditionInput
  ) {
    updatePointOfInterest(input: $input, condition: $condition) {
      id
      name
      languageKey
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePointOfInterest = /* GraphQL */ `
  mutation DeletePointOfInterest(
    $input: DeletePointOfInterestInput!
    $condition: ModelPointOfInterestConditionInput
  ) {
    deletePointOfInterest(input: $input, condition: $condition) {
      id
      name
      languageKey
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createMediaItem = /* GraphQL */ `
  mutation CreateMediaItem(
    $input: CreateMediaItemInput!
    $condition: ModelMediaItemConditionInput
  ) {
    createMediaItem(input: $input, condition: $condition) {
      id
      carrierId
      category
      drmCount
      minCount
      maxCount
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateMediaItem = /* GraphQL */ `
  mutation UpdateMediaItem(
    $input: UpdateMediaItemInput!
    $condition: ModelMediaItemConditionInput
  ) {
    updateMediaItem(input: $input, condition: $condition) {
      id
      carrierId
      category
      drmCount
      minCount
      maxCount
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteMediaItem = /* GraphQL */ `
  mutation DeleteMediaItem(
    $input: DeleteMediaItemInput!
    $condition: ModelMediaItemConditionInput
  ) {
    deleteMediaItem(input: $input, condition: $condition) {
      id
      carrierId
      category
      drmCount
      minCount
      maxCount
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCarrier = /* GraphQL */ `
  mutation CreateCarrier(
    $input: CreateCarrierInput!
    $condition: ModelCarrierConditionInput
  ) {
    createCarrier(input: $input, condition: $condition) {
      id
      carrierName
      bukcet
      iataode
      contractType
      emailAddress
      isActive
      Manifests {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCarrier = /* GraphQL */ `
  mutation UpdateCarrier(
    $input: UpdateCarrierInput!
    $condition: ModelCarrierConditionInput
  ) {
    updateCarrier(input: $input, condition: $condition) {
      id
      carrierName
      bukcet
      iataode
      contractType
      emailAddress
      isActive
      Manifests {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCarrier = /* GraphQL */ `
  mutation DeleteCarrier(
    $input: DeleteCarrierInput!
    $condition: ModelCarrierConditionInput
  ) {
    deleteCarrier(input: $input, condition: $condition) {
      id
      carrierName
      bukcet
      iataode
      contractType
      emailAddress
      isActive
      Manifests {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createManifest = /* GraphQL */ `
  mutation CreateManifest(
    $input: CreateManifestInput!
    $condition: ModelManifestConditionInput
  ) {
    createManifest(input: $input, condition: $condition) {
      id
      title
      carrierId
      carrier {
        id
        carrierName
        bukcet
        iataode
        contractType
        emailAddress
        isActive
        createdAt
        updatedAt
        __typename
      }
      adminApproved
      carrierApproved
      adminComments
      carrierComments
      manifestDate
      contentStartDate
      contentEndDate
      isActive
      isManifestDeployed
      DeploymentDate
      bucket
      date
      ManifestItems {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateManifest = /* GraphQL */ `
  mutation UpdateManifest(
    $input: UpdateManifestInput!
    $condition: ModelManifestConditionInput
  ) {
    updateManifest(input: $input, condition: $condition) {
      id
      title
      carrierId
      carrier {
        id
        carrierName
        bukcet
        iataode
        contractType
        emailAddress
        isActive
        createdAt
        updatedAt
        __typename
      }
      adminApproved
      carrierApproved
      adminComments
      carrierComments
      manifestDate
      contentStartDate
      contentEndDate
      isActive
      isManifestDeployed
      DeploymentDate
      bucket
      date
      ManifestItems {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteManifest = /* GraphQL */ `
  mutation DeleteManifest(
    $input: DeleteManifestInput!
    $condition: ModelManifestConditionInput
  ) {
    deleteManifest(input: $input, condition: $condition) {
      id
      title
      carrierId
      carrier {
        id
        carrierName
        bukcet
        iataode
        contractType
        emailAddress
        isActive
        createdAt
        updatedAt
        __typename
      }
      adminApproved
      carrierApproved
      adminComments
      carrierComments
      manifestDate
      contentStartDate
      contentEndDate
      isActive
      isManifestDeployed
      DeploymentDate
      bucket
      date
      ManifestItems {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createManifestItem = /* GraphQL */ `
  mutation CreateManifestItem(
    $input: CreateManifestItemInput!
    $condition: ModelManifestItemConditionInput
  ) {
    createManifestItem(input: $input, condition: $condition) {
      id
      providerId
      isActive
      manifestID
      contentId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateManifestItem = /* GraphQL */ `
  mutation UpdateManifestItem(
    $input: UpdateManifestItemInput!
    $condition: ModelManifestItemConditionInput
  ) {
    updateManifestItem(input: $input, condition: $condition) {
      id
      providerId
      isActive
      manifestID
      contentId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteManifestItem = /* GraphQL */ `
  mutation DeleteManifestItem(
    $input: DeleteManifestItemInput!
    $condition: ModelManifestItemConditionInput
  ) {
    deleteManifestItem(input: $input, condition: $condition) {
      id
      providerId
      isActive
      manifestID
      contentId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createEntertainment = /* GraphQL */ `
  mutation CreateEntertainment(
    $input: CreateEntertainmentInput!
    $condition: ModelEntertainmentConditionInput
  ) {
    createEntertainment(input: $input, condition: $condition) {
      id
      actors
      awards
      boxOffice
      country
      director
      dvd
      genre
      imdbId
      imdbRating
      imdbVotes
      language
      metaScore
      plot
      poster
      production
      rated
      released
      runtime
      title
      rottenTomatoConsensus
      rottenTomatoFresh
      rottenTomatoImage
      rottenTomatoMeter
      rottenTomatoRating
      rottenTomatoReviews
      rottenTomatoRotten
      rottenTomatoUrl
      rottenTomatoUserMeter
      rottenTomatoUserRating
      rottenTomatoUserReviews
      type
      website
      writer
      year
      contentType
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateEntertainment = /* GraphQL */ `
  mutation UpdateEntertainment(
    $input: UpdateEntertainmentInput!
    $condition: ModelEntertainmentConditionInput
  ) {
    updateEntertainment(input: $input, condition: $condition) {
      id
      actors
      awards
      boxOffice
      country
      director
      dvd
      genre
      imdbId
      imdbRating
      imdbVotes
      language
      metaScore
      plot
      poster
      production
      rated
      released
      runtime
      title
      rottenTomatoConsensus
      rottenTomatoFresh
      rottenTomatoImage
      rottenTomatoMeter
      rottenTomatoRating
      rottenTomatoReviews
      rottenTomatoRotten
      rottenTomatoUrl
      rottenTomatoUserMeter
      rottenTomatoUserRating
      rottenTomatoUserReviews
      type
      website
      writer
      year
      contentType
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteEntertainment = /* GraphQL */ `
  mutation DeleteEntertainment(
    $input: DeleteEntertainmentInput!
    $condition: ModelEntertainmentConditionInput
  ) {
    deleteEntertainment(input: $input, condition: $condition) {
      id
      actors
      awards
      boxOffice
      country
      director
      dvd
      genre
      imdbId
      imdbRating
      imdbVotes
      language
      metaScore
      plot
      poster
      production
      rated
      released
      runtime
      title
      rottenTomatoConsensus
      rottenTomatoFresh
      rottenTomatoImage
      rottenTomatoMeter
      rottenTomatoRating
      rottenTomatoReviews
      rottenTomatoRotten
      rottenTomatoUrl
      rottenTomatoUserMeter
      rottenTomatoUserRating
      rottenTomatoUserReviews
      type
      website
      writer
      year
      contentType
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCity = /* GraphQL */ `
  mutation CreateCity(
    $input: CreateCityInput!
    $condition: ModelCityConditionInput
  ) {
    createCity(input: $input, condition: $condition) {
      id
      countryId
      name
      nativeName
      picture
      summary
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCity = /* GraphQL */ `
  mutation UpdateCity(
    $input: UpdateCityInput!
    $condition: ModelCityConditionInput
  ) {
    updateCity(input: $input, condition: $condition) {
      id
      countryId
      name
      nativeName
      picture
      summary
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCity = /* GraphQL */ `
  mutation DeleteCity(
    $input: DeleteCityInput!
    $condition: ModelCityConditionInput
  ) {
    deleteCity(input: $input, condition: $condition) {
      id
      countryId
      name
      nativeName
      picture
      summary
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOneDriveContent = /* GraphQL */ `
  mutation CreateOneDriveContent(
    $input: CreateOneDriveContentInput!
    $condition: ModelOneDriveContentConditionInput
  ) {
    createOneDriveContent(input: $input, condition: $condition) {
      id
      files {
        filePath
        downloadUrl
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOneDriveContent = /* GraphQL */ `
  mutation UpdateOneDriveContent(
    $input: UpdateOneDriveContentInput!
    $condition: ModelOneDriveContentConditionInput
  ) {
    updateOneDriveContent(input: $input, condition: $condition) {
      id
      files {
        filePath
        downloadUrl
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOneDriveContent = /* GraphQL */ `
  mutation DeleteOneDriveContent(
    $input: DeleteOneDriveContentInput!
    $condition: ModelOneDriveContentConditionInput
  ) {
    deleteOneDriveContent(input: $input, condition: $condition) {
      id
      files {
        filePath
        downloadUrl
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createNewContent = /* GraphQL */ `
  mutation CreateNewContent(
    $input: CreateNewContentInput!
    $condition: ModelNewContentConditionInput
  ) {
    createNewContent(input: $input, condition: $condition) {
      id
      title
      type
      category
      director
      actors
      duration
      releaseDate
      description
      language
      filePath
      rating
      studio
      country
      year
      posters
      licensingInfo
      fileSize
      creators
      author
      genre
      publisher
      publicationYear
      isSeries
      isDrmProtected
      isDrmEncodedSuccessfully
      axinomDrmEncodingJobId
      encodedFilePath
      encodedFolderPath
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateNewContent = /* GraphQL */ `
  mutation UpdateNewContent(
    $input: UpdateNewContentInput!
    $condition: ModelNewContentConditionInput
  ) {
    updateNewContent(input: $input, condition: $condition) {
      id
      title
      type
      category
      director
      actors
      duration
      releaseDate
      description
      language
      filePath
      rating
      studio
      country
      year
      posters
      licensingInfo
      fileSize
      creators
      author
      genre
      publisher
      publicationYear
      isSeries
      isDrmProtected
      isDrmEncodedSuccessfully
      axinomDrmEncodingJobId
      encodedFilePath
      encodedFolderPath
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteNewContent = /* GraphQL */ `
  mutation DeleteNewContent(
    $input: DeleteNewContentInput!
    $condition: ModelNewContentConditionInput
  ) {
    deleteNewContent(input: $input, condition: $condition) {
      id
      title
      type
      category
      director
      actors
      duration
      releaseDate
      description
      language
      filePath
      rating
      studio
      country
      year
      posters
      licensingInfo
      fileSize
      creators
      author
      genre
      publisher
      publicationYear
      isSeries
      isDrmProtected
      isDrmEncodedSuccessfully
      axinomDrmEncodingJobId
      encodedFilePath
      encodedFolderPath
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCountry = /* GraphQL */ `
  mutation CreateCountry(
    $input: CreateCountryInput!
    $condition: ModelCountryConditionInput
  ) {
    createCountry(input: $input, condition: $condition) {
      id
      name
      nativeName
      code
      summary
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCountry = /* GraphQL */ `
  mutation UpdateCountry(
    $input: UpdateCountryInput!
    $condition: ModelCountryConditionInput
  ) {
    updateCountry(input: $input, condition: $condition) {
      id
      name
      nativeName
      code
      summary
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCountry = /* GraphQL */ `
  mutation DeleteCountry(
    $input: DeleteCountryInput!
    $condition: ModelCountryConditionInput
  ) {
    deleteCountry(input: $input, condition: $condition) {
      id
      name
      nativeName
      code
      summary
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDestination = /* GraphQL */ `
  mutation CreateDestination(
    $input: CreateDestinationInput!
    $condition: ModelDestinationConditionInput
  ) {
    createDestination(input: $input, condition: $condition) {
      id
      languageId
      countryId
      cityId
      pointOfInterestId
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDestination = /* GraphQL */ `
  mutation UpdateDestination(
    $input: UpdateDestinationInput!
    $condition: ModelDestinationConditionInput
  ) {
    updateDestination(input: $input, condition: $condition) {
      id
      languageId
      countryId
      cityId
      pointOfInterestId
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDestination = /* GraphQL */ `
  mutation DeleteDestination(
    $input: DeleteDestinationInput!
    $condition: ModelDestinationConditionInput
  ) {
    deleteDestination(input: $input, condition: $condition) {
      id
      languageId
      countryId
      cityId
      pointOfInterestId
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDestinationItem = /* GraphQL */ `
  mutation CreateDestinationItem(
    $input: CreateDestinationItemInput!
    $condition: ModelDestinationItemConditionInput
  ) {
    createDestinationItem(input: $input, condition: $condition) {
      id
      destinationId
      pointOfInterestId
      carrierId
      bucket
      iataCode
      title
      summary
      picture
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDestinationItem = /* GraphQL */ `
  mutation UpdateDestinationItem(
    $input: UpdateDestinationItemInput!
    $condition: ModelDestinationItemConditionInput
  ) {
    updateDestinationItem(input: $input, condition: $condition) {
      id
      destinationId
      pointOfInterestId
      carrierId
      bucket
      iataCode
      title
      summary
      picture
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDestinationItem = /* GraphQL */ `
  mutation DeleteDestinationItem(
    $input: DeleteDestinationItemInput!
    $condition: ModelDestinationItemConditionInput
  ) {
    deleteDestinationItem(input: $input, condition: $condition) {
      id
      destinationId
      pointOfInterestId
      carrierId
      bucket
      iataCode
      title
      summary
      picture
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDestinationItemCategory = /* GraphQL */ `
  mutation CreateDestinationItemCategory(
    $input: CreateDestinationItemCategoryInput!
    $condition: ModelDestinationItemCategoryConditionInput
  ) {
    createDestinationItemCategory(input: $input, condition: $condition) {
      id
      destinationId
      destinationItemId
      title
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDestinationItemCategory = /* GraphQL */ `
  mutation UpdateDestinationItemCategory(
    $input: UpdateDestinationItemCategoryInput!
    $condition: ModelDestinationItemCategoryConditionInput
  ) {
    updateDestinationItemCategory(input: $input, condition: $condition) {
      id
      destinationId
      destinationItemId
      title
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDestinationItemCategory = /* GraphQL */ `
  mutation DeleteDestinationItemCategory(
    $input: DeleteDestinationItemCategoryInput!
    $condition: ModelDestinationItemCategoryConditionInput
  ) {
    deleteDestinationItemCategory(input: $input, condition: $condition) {
      id
      destinationId
      destinationItemId
      title
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDestinationItemCategorySubitem = /* GraphQL */ `
  mutation CreateDestinationItemCategorySubitem(
    $input: CreateDestinationItemCategorySubitemInput!
    $condition: ModelDestinationItemCategorySubitemConditionInput
  ) {
    createDestinationItemCategorySubitem(input: $input, condition: $condition) {
      id
      destinationItemId
      destinationItemCategoryId
      title
      details
      picture
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDestinationItemCategorySubitem = /* GraphQL */ `
  mutation UpdateDestinationItemCategorySubitem(
    $input: UpdateDestinationItemCategorySubitemInput!
    $condition: ModelDestinationItemCategorySubitemConditionInput
  ) {
    updateDestinationItemCategorySubitem(input: $input, condition: $condition) {
      id
      destinationItemId
      destinationItemCategoryId
      title
      details
      picture
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDestinationItemCategorySubitem = /* GraphQL */ `
  mutation DeleteDestinationItemCategorySubitem(
    $input: DeleteDestinationItemCategorySubitemInput!
    $condition: ModelDestinationItemCategorySubitemConditionInput
  ) {
    deleteDestinationItemCategorySubitem(input: $input, condition: $condition) {
      id
      destinationItemId
      destinationItemCategoryId
      title
      details
      picture
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSearchContent = /* GraphQL */ `
  mutation CreateSearchContent(
    $input: CreateSearchContentInput!
    $condition: ModelSearchContentConditionInput
  ) {
    createSearchContent(input: $input, condition: $condition) {
      id
      providerId
      actors
      album
      awards
      boxOffice
      country
      director
      dvd
      genre
      imdbId
      imdbRating
      imdbVotes
      language
      metaScore
      plot
      poster
      production
      rated
      released
      runtime
      title
      titleAsBase64
      rottenTomatoConsensus
      rottenTomatoFresh
      rottenTomatoImage
      rottenTomatoMeter
      rottenTomatoRating
      rottenTomatoReviews
      rottenTomatoRotten
      rottenTomatoUrl
      rottenTomatoUserMeter
      rottenTomatoUserRating
      rottenTomatoUserReviews
      type
      category
      trailer
      website
      writer
      year
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSearchContent = /* GraphQL */ `
  mutation UpdateSearchContent(
    $input: UpdateSearchContentInput!
    $condition: ModelSearchContentConditionInput
  ) {
    updateSearchContent(input: $input, condition: $condition) {
      id
      providerId
      actors
      album
      awards
      boxOffice
      country
      director
      dvd
      genre
      imdbId
      imdbRating
      imdbVotes
      language
      metaScore
      plot
      poster
      production
      rated
      released
      runtime
      title
      titleAsBase64
      rottenTomatoConsensus
      rottenTomatoFresh
      rottenTomatoImage
      rottenTomatoMeter
      rottenTomatoRating
      rottenTomatoReviews
      rottenTomatoRotten
      rottenTomatoUrl
      rottenTomatoUserMeter
      rottenTomatoUserRating
      rottenTomatoUserReviews
      type
      category
      trailer
      website
      writer
      year
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSearchContent = /* GraphQL */ `
  mutation DeleteSearchContent(
    $input: DeleteSearchContentInput!
    $condition: ModelSearchContentConditionInput
  ) {
    deleteSearchContent(input: $input, condition: $condition) {
      id
      providerId
      actors
      album
      awards
      boxOffice
      country
      director
      dvd
      genre
      imdbId
      imdbRating
      imdbVotes
      language
      metaScore
      plot
      poster
      production
      rated
      released
      runtime
      title
      titleAsBase64
      rottenTomatoConsensus
      rottenTomatoFresh
      rottenTomatoImage
      rottenTomatoMeter
      rottenTomatoRating
      rottenTomatoReviews
      rottenTomatoRotten
      rottenTomatoUrl
      rottenTomatoUserMeter
      rottenTomatoUserRating
      rottenTomatoUserReviews
      type
      category
      trailer
      website
      writer
      year
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAdvertiser = /* GraphQL */ `
  mutation CreateAdvertiser(
    $input: CreateAdvertiserInput!
    $condition: ModelAdvertiserConditionInput
  ) {
    createAdvertiser(input: $input, condition: $condition) {
      id
      name
      email
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAdvertiser = /* GraphQL */ `
  mutation UpdateAdvertiser(
    $input: UpdateAdvertiserInput!
    $condition: ModelAdvertiserConditionInput
  ) {
    updateAdvertiser(input: $input, condition: $condition) {
      id
      name
      email
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAdvertiser = /* GraphQL */ `
  mutation DeleteAdvertiser(
    $input: DeleteAdvertiserInput!
    $condition: ModelAdvertiserConditionInput
  ) {
    deleteAdvertiser(input: $input, condition: $condition) {
      id
      name
      email
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCampaign = /* GraphQL */ `
  mutation CreateCampaign(
    $input: CreateCampaignInput!
    $condition: ModelCampaignConditionInput
  ) {
    createCampaign(input: $input, condition: $condition) {
      id
      name
      startDate
      endDate
      budget
      totalDurationOfAds
      estimatedCostOfCampaign
      approvedCostOfCampaign
      status
      paid
      keywords
      adverts {
        nextToken
        __typename
      }
      banktransfers {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCampaign = /* GraphQL */ `
  mutation UpdateCampaign(
    $input: UpdateCampaignInput!
    $condition: ModelCampaignConditionInput
  ) {
    updateCampaign(input: $input, condition: $condition) {
      id
      name
      startDate
      endDate
      budget
      totalDurationOfAds
      estimatedCostOfCampaign
      approvedCostOfCampaign
      status
      paid
      keywords
      adverts {
        nextToken
        __typename
      }
      banktransfers {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCampaign = /* GraphQL */ `
  mutation DeleteCampaign(
    $input: DeleteCampaignInput!
    $condition: ModelCampaignConditionInput
  ) {
    deleteCampaign(input: $input, condition: $condition) {
      id
      name
      startDate
      endDate
      budget
      totalDurationOfAds
      estimatedCostOfCampaign
      approvedCostOfCampaign
      status
      paid
      keywords
      adverts {
        nextToken
        __typename
      }
      banktransfers {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAdvert = /* GraphQL */ `
  mutation CreateAdvert(
    $input: CreateAdvertInput!
    $condition: ModelAdvertConditionInput
  ) {
    createAdvert(input: $input, condition: $condition) {
      id
      title
      type
      keywords
      filePath
      duration
      status
      campaigns {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAdvert = /* GraphQL */ `
  mutation UpdateAdvert(
    $input: UpdateAdvertInput!
    $condition: ModelAdvertConditionInput
  ) {
    updateAdvert(input: $input, condition: $condition) {
      id
      title
      type
      keywords
      filePath
      duration
      status
      campaigns {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAdvert = /* GraphQL */ `
  mutation DeleteAdvert(
    $input: DeleteAdvertInput!
    $condition: ModelAdvertConditionInput
  ) {
    deleteAdvert(input: $input, condition: $condition) {
      id
      title
      type
      keywords
      filePath
      duration
      status
      campaigns {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCampaignAdvertInventory = /* GraphQL */ `
  mutation CreateCampaignAdvertInventory(
    $input: CreateCampaignAdvertInventoryInput!
    $condition: ModelCampaignAdvertInventoryConditionInput
  ) {
    createCampaignAdvertInventory(input: $input, condition: $condition) {
      id
      advertId
      advert {
        id
        title
        type
        keywords
        filePath
        duration
        status
        createdAt
        updatedAt
        __typename
      }
      campaignId
      campaign {
        id
        name
        startDate
        endDate
        budget
        totalDurationOfAds
        estimatedCostOfCampaign
        approvedCostOfCampaign
        status
        paid
        keywords
        createdAt
        updatedAt
        __typename
      }
      preRollIsSkippable
      preRollSkipAfter
      preRollDuration
      midRollIsSkippable
      midRollSkipAfter
      midRollDuration
      postRollIsSkippable
      postRollSkipAfter
      postRollDuration
      requestStatus
      requestDeclineReason
      totalDuration
      totalCost
      paid
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCampaignAdvertInventory = /* GraphQL */ `
  mutation UpdateCampaignAdvertInventory(
    $input: UpdateCampaignAdvertInventoryInput!
    $condition: ModelCampaignAdvertInventoryConditionInput
  ) {
    updateCampaignAdvertInventory(input: $input, condition: $condition) {
      id
      advertId
      advert {
        id
        title
        type
        keywords
        filePath
        duration
        status
        createdAt
        updatedAt
        __typename
      }
      campaignId
      campaign {
        id
        name
        startDate
        endDate
        budget
        totalDurationOfAds
        estimatedCostOfCampaign
        approvedCostOfCampaign
        status
        paid
        keywords
        createdAt
        updatedAt
        __typename
      }
      preRollIsSkippable
      preRollSkipAfter
      preRollDuration
      midRollIsSkippable
      midRollSkipAfter
      midRollDuration
      postRollIsSkippable
      postRollSkipAfter
      postRollDuration
      requestStatus
      requestDeclineReason
      totalDuration
      totalCost
      paid
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCampaignAdvertInventory = /* GraphQL */ `
  mutation DeleteCampaignAdvertInventory(
    $input: DeleteCampaignAdvertInventoryInput!
    $condition: ModelCampaignAdvertInventoryConditionInput
  ) {
    deleteCampaignAdvertInventory(input: $input, condition: $condition) {
      id
      advertId
      advert {
        id
        title
        type
        keywords
        filePath
        duration
        status
        createdAt
        updatedAt
        __typename
      }
      campaignId
      campaign {
        id
        name
        startDate
        endDate
        budget
        totalDurationOfAds
        estimatedCostOfCampaign
        approvedCostOfCampaign
        status
        paid
        keywords
        createdAt
        updatedAt
        __typename
      }
      preRollIsSkippable
      preRollSkipAfter
      preRollDuration
      midRollIsSkippable
      midRollSkipAfter
      midRollDuration
      postRollIsSkippable
      postRollSkipAfter
      postRollDuration
      requestStatus
      requestDeclineReason
      totalDuration
      totalCost
      paid
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAdDetail = /* GraphQL */ `
  mutation CreateAdDetail(
    $input: CreateAdDetailInput!
    $condition: ModelAdDetailConditionInput
  ) {
    createAdDetail(input: $input, condition: $condition) {
      id
      playOrder
      numberOfAds
      minutesOfAds
      isSkippable
      pricing
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAdDetail = /* GraphQL */ `
  mutation UpdateAdDetail(
    $input: UpdateAdDetailInput!
    $condition: ModelAdDetailConditionInput
  ) {
    updateAdDetail(input: $input, condition: $condition) {
      id
      playOrder
      numberOfAds
      minutesOfAds
      isSkippable
      pricing
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAdDetail = /* GraphQL */ `
  mutation DeleteAdDetail(
    $input: DeleteAdDetailInput!
    $condition: ModelAdDetailConditionInput
  ) {
    deleteAdDetail(input: $input, condition: $condition) {
      id
      playOrder
      numberOfAds
      minutesOfAds
      isSkippable
      pricing
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOrder = /* GraphQL */ `
  mutation CreateOrder(
    $input: CreateOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    createOrder(input: $input, condition: $condition) {
      id
      orderType
      linkedId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOrder = /* GraphQL */ `
  mutation UpdateOrder(
    $input: UpdateOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    updateOrder(input: $input, condition: $condition) {
      id
      orderType
      linkedId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOrder = /* GraphQL */ `
  mutation DeleteOrder(
    $input: DeleteOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    deleteOrder(input: $input, condition: $condition) {
      id
      orderType
      linkedId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBank = /* GraphQL */ `
  mutation CreateBank(
    $input: CreateBankInput!
    $condition: ModelBankConditionInput
  ) {
    createBank(input: $input, condition: $condition) {
      id
      bankName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBank = /* GraphQL */ `
  mutation UpdateBank(
    $input: UpdateBankInput!
    $condition: ModelBankConditionInput
  ) {
    updateBank(input: $input, condition: $condition) {
      id
      bankName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBank = /* GraphQL */ `
  mutation DeleteBank(
    $input: DeleteBankInput!
    $condition: ModelBankConditionInput
  ) {
    deleteBank(input: $input, condition: $condition) {
      id
      bankName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserProfile = /* GraphQL */ `
  mutation CreateUserProfile(
    $input: CreateUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    createUserProfile(input: $input, condition: $condition) {
      id
      fullName
      companyName
      emailAddress
      designation
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserProfile = /* GraphQL */ `
  mutation UpdateUserProfile(
    $input: UpdateUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    updateUserProfile(input: $input, condition: $condition) {
      id
      fullName
      companyName
      emailAddress
      designation
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserProfile = /* GraphQL */ `
  mutation DeleteUserProfile(
    $input: DeleteUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    deleteUserProfile(input: $input, condition: $condition) {
      id
      fullName
      companyName
      emailAddress
      designation
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCloudAccount = /* GraphQL */ `
  mutation CreateCloudAccount(
    $input: CreateCloudAccountInput!
    $condition: ModelCloudAccountConditionInput
  ) {
    createCloudAccount(input: $input, condition: $condition) {
      id
      account
      refreshToken
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCloudAccount = /* GraphQL */ `
  mutation UpdateCloudAccount(
    $input: UpdateCloudAccountInput!
    $condition: ModelCloudAccountConditionInput
  ) {
    updateCloudAccount(input: $input, condition: $condition) {
      id
      account
      refreshToken
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCloudAccount = /* GraphQL */ `
  mutation DeleteCloudAccount(
    $input: DeleteCloudAccountInput!
    $condition: ModelCloudAccountConditionInput
  ) {
    deleteCloudAccount(input: $input, condition: $condition) {
      id
      account
      refreshToken
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserBankAccount = /* GraphQL */ `
  mutation CreateUserBankAccount(
    $input: CreateUserBankAccountInput!
    $condition: ModelUserBankAccountConditionInput
  ) {
    createUserBankAccount(input: $input, condition: $condition) {
      id
      bankName
      accountTitle
      accountNumber
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserBankAccount = /* GraphQL */ `
  mutation UpdateUserBankAccount(
    $input: UpdateUserBankAccountInput!
    $condition: ModelUserBankAccountConditionInput
  ) {
    updateUserBankAccount(input: $input, condition: $condition) {
      id
      bankName
      accountTitle
      accountNumber
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserBankAccount = /* GraphQL */ `
  mutation DeleteUserBankAccount(
    $input: DeleteUserBankAccountInput!
    $condition: ModelUserBankAccountConditionInput
  ) {
    deleteUserBankAccount(input: $input, condition: $condition) {
      id
      bankName
      accountTitle
      accountNumber
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBankTransfer = /* GraphQL */ `
  mutation CreateBankTransfer(
    $input: CreateBankTransferInput!
    $condition: ModelBankTransferConditionInput
  ) {
    createBankTransfer(input: $input, condition: $condition) {
      id
      amount
      accountHolderName
      accountNumber
      bankName
      type
      receiptUrl
      reference
      paymentStatus
      campaignId
      campaign {
        id
        name
        startDate
        endDate
        budget
        totalDurationOfAds
        estimatedCostOfCampaign
        approvedCostOfCampaign
        status
        paid
        keywords
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBankTransfer = /* GraphQL */ `
  mutation UpdateBankTransfer(
    $input: UpdateBankTransferInput!
    $condition: ModelBankTransferConditionInput
  ) {
    updateBankTransfer(input: $input, condition: $condition) {
      id
      amount
      accountHolderName
      accountNumber
      bankName
      type
      receiptUrl
      reference
      paymentStatus
      campaignId
      campaign {
        id
        name
        startDate
        endDate
        budget
        totalDurationOfAds
        estimatedCostOfCampaign
        approvedCostOfCampaign
        status
        paid
        keywords
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBankTransfer = /* GraphQL */ `
  mutation DeleteBankTransfer(
    $input: DeleteBankTransferInput!
    $condition: ModelBankTransferConditionInput
  ) {
    deleteBankTransfer(input: $input, condition: $condition) {
      id
      amount
      accountHolderName
      accountNumber
      bankName
      type
      receiptUrl
      reference
      paymentStatus
      campaignId
      campaign {
        id
        name
        startDate
        endDate
        budget
        totalDurationOfAds
        estimatedCostOfCampaign
        approvedCostOfCampaign
        status
        paid
        keywords
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
